<template>
  <div class="px-3 py-5 shadow">
    <div class="mb-3">
      <button
          class="btn btn-primary"
          @click="showTotal = true">
        Лист заключений
      </button>
    </div>

    <ConclusionDiagnoses
        :diagnoses="diagnoses"
        :establishments="diagnosisEstablishments"
        :submitDiagnosisEstablishment="submitDiagnosisEstablishment"
        :deleteDiagnosisEstablishment="deleteDiagnosisEstablishment"/>

    <ConclusionFunctionals
        :functionals="functionals"
        :establishments="functionalEstablishments"
        :submitFunctionalEstablishment="submitFunctionalEstablishment"
        :deleteFunctionalEstablishment="deleteFunctionalEstablishment"/>

    <ConclusionAnamnesis
        :anamneses="anamneses"
        :submitAnamnesis="submitAnamnesis"
        :deleteAnamnesis="deleteAnamnesis"/>

    <ConclusionConclusions
        :conclusions="conclusions"
        :submitConclusion="submitConclusion"
        :deleteConclusion="deleteConclusion"/>

    <ConclusionTotal
        v-if="showTotal"
        :conclusions="conclusions"
        :diagnoses="diagnoses"
        :diagnosisEstablishments="diagnosisEstablishments"
        :functionals="functionals"
        :functionalEstablishments="functionalEstablishments"
        @cancel="showTotal = false" />
  </div>
</template>

<script>
import ConclusionConclusions from './conclusion/Conclusions';
import ConclusionDiagnoses from './conclusion/Diagnoses';
import ConclusionFunctionals from './conclusion/Functionals';
import ConclusionAnamnesis from './conclusion/Anamnesis';
import ConclusionTotal from './conclusion/Total';

export default {
  name: 'ClientConclusion',

  components: {
    ConclusionConclusions,
    ConclusionDiagnoses,
    ConclusionFunctionals,
    ConclusionAnamnesis,
    ConclusionTotal,
  },

  props: ['client'],

  data() {
    return {
      loading: true,
      showTotal: false,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    conclusions() {
      return this.$store.getters.clientConclusions(this.client.id);
    },

    diagnoses() {
      return this.$store.state.clinic.diagnoses;
    },

    diagnosisEstablishments() {
      return this.$store.getters.clientDiagnosisEstablishments(this.client.id);
    },

    functionals() {
      return this.$store.state.clinic.functionals;
    },

    functionalEstablishments() {
      return this.$store.getters.clientFunctionalEstablishments(this.client.id);
    },

    anamneses() {
      return this.$store.getters.clientAnamneses(this.client.id);
    },
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;

        await Promise.all([
          this.$store.dispatch('LOAD_CONCLUSIONS', this.client.id),
          this.$store.dispatch('LOAD_DIAGNOSES'),
          this.$store.dispatch('LOAD_DIAGNOSIS_ESTABLISHMENTS', this.client.id),
          this.$store.dispatch('LOAD_FUNCTIONALS'),
          this.$store.dispatch('LOAD_FUNCTIONAL_ESTABLISHMENTS', this.client.id),
          this.$store.dispatch('LOAD_ANAMNESES', this.client.id),
        ]);
      } catch (e) {
        this.$store.dispatch('ERROR', e);
      }

      this.loading = false;
    },

    async submitConclusion(data) {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      try {
        const {id, text, note, additional, dateFrom} = data;
        const params = {
          id,
          client: this.client.id,
          text,
          note,
          additional,
          dateFrom: new Date(dateFrom)
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('UPDATE_CONCLUSION', params);
        } else {
          await this.$store.dispatch('ADD_CONCLUSION', params);
        }
      } catch (e) {
        this.$store.dispatch('ERROR', e);
      }

      this.loading = false;
    },

    async deleteConclusion(id) {
      this.loading = true;

      try {
        const params = {
          id,
          user: this.client.id,
        };

        await this.$store.dispatch('DELETE_CONCLUSION', params);

        this.success = `Заключение успешно удалено`;
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async submitDiagnosisEstablishment(data) {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      try {
        const { id, diagnosis, note, dateFrom , dateTo, type } = data;
        const params = {
          id,
          client: this.client.id,
          diagnosis,
          type,
          note,
          dateFrom: new Date(dateFrom),
          dateTo: dateTo ? new Date(dateTo) : '',
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('UPDATE_DIAGNOSIS_ESTABLISHMENT', params);
        } else {
          await this.$store.dispatch('ADD_DIAGNOSIS_ESTABLISHMENT', params);
        }
      } catch (e) {
        this.$store.dispatch('ERROR', e);
      }

      this.loading = false;
    },

    async deleteDiagnosisEstablishment(id) {
      this.loading = true;

      try {
        const params = {
          id,
          user: this.client.id,
        };

        await this.$store.dispatch('DELETE_DIAGNOSIS_ESTABLISHMENT', params);

        this.success = `Диагноз успешно удален`;
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async submitFunctionalEstablishment(data) {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      try {
        const { id, functional, note, dateFrom , dateTo } = data;
        const params = {
          id,
          client: this.client.id,
          functional,
          note,
          dateFrom: new Date(dateFrom),
          dateTo: dateTo ? new Date(dateTo) : '',
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('UPDATE_FUNCTIONAL_ESTABLISHMENT', params);
        } else {
          await this.$store.dispatch('ADD_FUNCTIONAL_ESTABLISHMENT', params);
        }
      } catch (e) {
        this.$store.dispatch('ERROR', e);
      }

      this.loading = false;
    },

    async deleteFunctionalEstablishment(id) {
      this.loading = true;

      try {
        const params = {
          id,
          user: this.client.id,
        };

        await this.$store.dispatch('DELETE_FUNCTIONAL_ESTABLISHMENT', params);

        this.success = `Функциональное состояние успешно удалено`;
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async submitAnamnesis(data) {
      this.loading = true;

      try {
        const { id, text, date } = data;
        const params = {
          id,
          user: this.client.id,
          text,
          date: new Date(date),
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('UPDATE_ANAMNESIS', params);

          this.success = `Анамнез успешно обновлен`;
        } else {
          await this.$store.dispatch('ADD_ANAMNESIS', params);

          this.success = `Анамнез успешно добавлен`;
        }
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async deleteAnamnesis(id) {
      this.loading = true;

      try {
        const params = {
          id,
          user: this.client.id,
        };

        await this.$store.dispatch('DELETE_ANAMNESIS', params);

        this.success = `Анамнез успешно удален`;
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },
  },
};
</script>
